const AcceptedPayment = {
    Card: 1,
    Ach: 2,
    Affirm: 4,

    display: (type) => {
        switch (type) {
            case AcceptedPayment.Card:
                return "Credit Card"
            case AcceptedPayment.Ach:
                return "ACH"
            case AcceptedPayment.Affirm:
                return "Affirm"
        }
    },
    types: () => [AcceptedPayment.Card, AcceptedPayment.Ach, AcceptedPayment.Affirm]
}

const AccountTypes = {
    Gallery: 1,
    Artist: 2,

    display: (accountType) => {
        switch (accountType) {
            case AccountTypes.Artist:
                return 'Artist';
            case AccountTypes.Gallery:
                return 'Gallery';
        }
    },

    hasType: (accountTypes, type) => {
        return accountTypes & type
    }
};

const ActiveStatus = [
    { value: 1, label: 'All' },
    { value: 2, label: 'Active' },
    { value: 3, label: 'Inactive' }
];

const ActivityType = {
    Activity: {
        label: 'Activity',
        value: 4
    },
    Messages: {
        label: 'Messages',
        value: 3
    },
    Notifications: {
        label: 'All Notifications',
        value: 0
    }
}

const Address = [
    { value: 0, label: 'Billing' },
    { value: 1, label: 'Shipping' }
];

const AdminUserType = [
    { label: 'All' },
    { value: 0, label: 'Gallery' },
    { value: 1, label: 'Artist' },
    { value: 2, label: 'Collector' }
];

const AnalyticsDateRangeOptions = [
    { value: 1, label: 'Today' },
    { value: 2, label: 'Yesterday' },
    { value: 3, label: 'Week to Date' },
    { value: 4, label: 'Last Week' },
    { value: 5, label: 'Month to Date' },
    { value: 6, label: 'Last Month' },
    { value: 7, label: 'Quarter to Date' },
    { value: 8, label: 'Last Quarter' },
    { value: 9, label: 'Year to Date' },
    { value: 10, label: 'Last Year' },
    { value: 11, label: 'Custom' },
];

const BillingPermission = {
    Action: {
        CreateClient: "CreateClient",
        CreateInventory: "CreateInventory",
        CreateInvoice: "CreateInvoice",
        CreateLocation: "CreateLocation",
        CreateStaff: "CreateStaff",
        OptArtistWebsite: "OptArtistWebsite",
        OptInventoryWebsite: "OptInventoryWebsite",
        SendCampaign: "SendCampaign"
    },
    Reason: {
        InvalidPermission: 0,
        NoSubscription: 1,
        SubscriptionChangeRequired: 2,
        AdditionalCostIncurred: 3
    }
};

const Composition = {
    Type: {
        Header: 0,
        Footer: 1,
        Home: 2,
        InventoryProfile: 3,
        ArtistProfile: 4,
        ExhibitionProfile: 5,
        Contact: 6,
        InventoryPage: 7,
        ArtistsPage: 8,
        ExhibitionsPage: 9,
        Typography: 10,
        Colors: 11,
        Cell: {
            ArtistGrid: 12,
            Blog: 13,
            ExhibitionGrid: 14,
            ExhibitionParallax: 15,
            InventoryGrid: 16,
            InventoryWaterfall: 17,
            RecentlyViewed: 18
        },

        display: (value) => {
            switch (value) {
                case Composition.Type.ArtistProfile:
                    return 'Artist Profile';
                case Composition.Type.ArtistsPage:
                    return 'Artists Page';
                case Composition.Type.Cell.ArtistGrid:
                    return 'Artist Grid Cell';
                case Composition.Type.Cell.Blog:
                    return 'Blog Cell';
                case Composition.Type.Cell.ExhibitionGrid:
                    return 'Exhibition Grid Cell';
                case Composition.Type.Cell.ExhibitionParallax:
                    return 'Exhibition Parallax Cell';
                case Composition.Type.Cell.InventoryGrid:
                    return 'Inventory Grid Cell';
                case Composition.Type.Cell.InventoryWaterfall:
                    return 'Inventory Waterfall Cell';
                case Composition.Type.Cell.RecentlyViewed:
                    return 'Recently Viewed Cell';
                case Composition.Type.Colors:
                    return 'Colors';
                case Composition.Type.Contact:
                    return 'Contact Page';
                case Composition.Type.Footer:
                    return 'Footer';
                case Composition.Type.Header:
                    return 'Header';
                case Composition.Type.Home:
                    return 'Home Page';
                case Composition.Type.ExhibitionProfile:
                    return 'Exhibition Detail';
                case Composition.Type.ExhibitionsPage:
                    return 'Exhibitions Page';
                case Composition.Type.InventoryProfile:
                    return 'Inventory Detail';
                case Composition.Type.InventoryPage:
                    return 'Inventory Page';
                case Composition.Type.Typography:
                    return 'Typography';
            }
        },
        options: () => [
            Composition.Type.ArtistProfile,
            Composition.Type.ArtistsPage,
            Composition.Type.Colors,
            Composition.Type.Contact,
            Composition.Type.ExhibitionProfile,
            Composition.Type.ExhibitionsPage,
            Composition.Type.Footer,
            Composition.Type.Header,
            Composition.Type.Home,
            Composition.Type.InventoryProfile,
            Composition.Type.InventoryPage,
            Composition.Type.Typography,
            Composition.Type.Cell.ArtistGrid,
            Composition.Type.Cell.Blog,
            Composition.Type.Cell.ExhibitionGrid,
            Composition.Type.Cell.ExhibitionParallax,
            Composition.Type.Cell.InventoryGrid,
            Composition.Type.Cell.InventoryWaterfall,
            Composition.Type.Cell.RecentlyViewed,
        ].map(value => ({ value, label: Composition.Type.display(value) }))
    }
}

const Consignment = {
    Inbound: 0,
    ThirdParty: 1,
    InventoryReturn: 2,
    Gallery: 3,

    listActionType: (value) => {
        switch (value) {
            case Consignment.Inbound:
                return 1;
            case Consignment.ThirdParty:
                return 2;
            case Consignment.InventoryReturn:
                return 3;
            case Consignment.Gallery:
                return 4;
        }
    },

    nameForValue: (value) => {
        switch (value) {
            case Consignment.Inbound:
                return 'Inbound Consignment';
            case Consignment.ThirdParty:
                return 'Third Party Consignment';
            case Consignment.InventoryReturn:
                return 'Inventory Return';
            case Consignment.Gallery:
                return 'Gallery Consignment'
        }
    },

    options: [
        { value: 0, label: 'Consignment - Inbound' },
        { value: 1, label: 'Third Party Consignment' },
        { value: 2, label: 'Inventory Return' },
    ],

    optionsArtist: [
        { value: 3, label: 'Gallery Consignment' },
        { value: 2, label: 'Inventory Return' },
    ]
};

const ConsignmentCost = [
    { value: 1, label: 'Amount' },
    { value: 2, label: 'Percentage' }
];

const ConsignmentStatus = [
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Accepted' }
];

const Currency = {
    ExchangeRates: [
        'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
        'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV',
        'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF',
        'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUP', 'CVE', 'CZK',
        'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP',
        'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL',
        'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD',
        'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT',
        'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD',
        'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR',
        'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN',
        'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF',
        'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE', 'SOS', 'SRD',
        'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP',
        'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU',
        'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU',
        'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT',
        'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWG'
    ],
    Rounding: [
        { value: 0, label: 'No Rounding' },
        { value: 1, label: 'Ones' },
        { value: 2, label: 'Tens' },
        { value: 3, label: 'Hundreds' },
        { value: 4, label: 'Thousands' },
        { value: 5, label: 'Ten Thousands' }
    ]
};

const DateFormats = {
    formatStringForType: function (type) {
        switch (parseInt(type, 10)) {
            case 0:
                return 'M/D/YYYY';
            case 1:
                return 'D/MM/YYYY';
            default:
                return 'MM/DD/YYYY';
        }
    },
    options: [
        { value: 0, label: 'MMDDYYYY' },
        { value: 1, label: 'DDMMYYYY' }
    ]
};

const DayOfWeek = {
    nameForValue: function (value) {
        switch (value) {
            case 0:
                return 'Sunday';
            case 1:
                return 'Monday';
            case 2:
                return 'Tuesday';
            case 3:
                return 'Wednesday';
            case 4:
                return 'Thursday';
            case 5:
                return 'Friday';
            case 6:
                return 'Saturday';
        }
    },

    valueForName: function (name) {
        switch (name) {
            case 'Sunday':
                return 0;
            case 'Monday':
                return 1;
            case 'Tuesday':
                return 2;
            case 'Wednesday':
                return 3;
            case 'Thursday':
                return 4;
            case 'Friday':
                return 5;
            case 'Saturday':
                return 6;
        }
    }
};

const DetailsDisplay = [
    { value: 0, label: "Modal" },
    { value: 1, label: "Page" }
];

const Edition = {
    Original: 0,
    Limited: 1,
    Unlimited: 2,

    options: function (includeOriginal) {
        let options = [
            { value: Edition.Limited, label: 'Limited' },
            { value: Edition.Unlimited, label: 'Unlimited' }
        ];
        if (includeOriginal != false) {
            options.splice(0, 0, { value: Edition.Original, label: 'Original' });
        }
        return options;
    }
};

const Email = {
    InquiryResponse: 'inquiry',
    InventoryInquiryResponse: 'inventoryInquiry',
    PurchaseConfirmation: 'purchaseConfirmation',

    display: (type) => {
        switch (type) {
            case Email.InquiryResponse:
                return "Inquiry Response";
            case Email.InventoryInquiryResponse:
                return "Inventory Inquiry Response";
            case Email.PurchaseConfirmation:
                return "Purchase Confirmation";
        }
    },

    value: (type) => {
        switch (type) {
            case Email.InventoryInquiryResponse:
                return 0;
            case Email.InquiryResponse:
                return 1;
            case Email.PurchaseConfirmation:
                return 2;
        }
    }
};

const Font = [
    { value: 1, label: 'Times New Roman' },
    { value: 2, label: 'Arial' },
    { value: 6, label: 'Open Sans' },
    { value: 7, label: 'Abril Fatface' },
    { value: 8, label: 'Exo 2' },
    { value: 9, label: 'Montserrat' },
    { value: 10, label: 'News Cycle' },
    { value: 11, label: 'Pinyon Script' },
    { value: 12, label: 'Lato' },
    { value: 13, label: 'Archivo' },
    { value: 14, label: 'Titillium Web' },
    { value: 15, label: 'Futura' },
    { value: 16, label: 'Raleway Light' },
    { value: 17, label: 'Cormorant Garamond' },
    { value: 18, label: 'Gyre Adventor' },
    { value: 19, label: 'Avenir' },
    { value: 20, label: 'Libre Franklin' },
    { value: 21, label: 'Josefin Sans' },
    { value: 22, label: 'Minion Pro' },
    { value: 23, label: 'Avenir Book' },
    { value: 24, label: 'Avenir Medium' },
    { value: 25, label: 'Roboto' },
    { value: 26, label: 'Homepage-Baukasten Book' },
    { value: 27, label: 'Regencie Light' },
    { value: 28, label: 'Century Gothic' },
    { value: 29, label: 'Recoleta' },
    { value: 30, label: 'TT Jenevers' },
    { value: 31, label: 'Borna' },
    { value: 32, label: 'Mr Eaves Sans' },
    { value: 33, label: 'TT Barrels' },
];

const Gate = {
    Analytics: 'analytics',
    Artsy: 'artsy',
    Audiences: 'audiences',
    Billing: 'billing',
    Builder: {
        BlockConfig: 'builder_blockConfig',
        Blocks: 'builder_blocks',
        Filter: 'builder_filter',
        IncludeVirtualInstall: 'builder_includeVirtualInstall',
        ResourceLinking: 'builder_resourceLinking',
        Tabs: 'builder_tabs'
    },
    Campaigns: 'campaigns',
    Contacts: 'clients',
    Collateral: 'collateral',
    EmailTemplates: 'emailTemplates',
    InventoryFinancials: 'inventoryFinancials',
    InventorySEO: 'inventorySEO',
    Invoices: 'invoices',
    Marketplace: 'marketplace',
    MarketplaceAnalytics: 'marketplaceAnalytics',
    Messages: 'messages',
    Opportunities: 'opportunities',
    PurchaseOrders: 'purchaseOrders',
    SocialCatalogs: 'socialCatalogs',
    StripeExpress: 'stripeExpress',
    Todos: 'todos',
    Website: 'website',
    WebsiteDomain: 'websiteDomain',
    WebsitePassword: 'websitePassword'
}

const Genre = [
    { value: 0, label: 'Unselected' },
    { value: 1, label: 'Conceptual' },
    { value: 2, label: 'Abstract' },
    { value: 3, label: 'Landscape' },
    { value: 4, label: 'Figurative' },
    { value: 5, label: 'Still Life' }
];

const Inventory = {
    Artwork: 0,
    Merchandise: 1,
    Jewelry: 5,
    Furniture: 6,
    Lighting: 7,
    Decor: 8,

    isNonEditionedType: (value, merchTypeValue) => {
        const _merchTypeValue = merchTypeValue != undefined ? merchTypeValue : Inventory.Merchandise
        switch (value) {
            case Inventory.Decor:
            case Inventory.Furniture:
            case Inventory.Jewelry:
            case Inventory.Lighting:
            case _merchTypeValue:
                return true;
            default:
                return false;
        }
    },
    nameForValue: (value) => {
        switch (value) {
            case Inventory.Merchandise:
                return 'Merchandise';
            case Inventory.Jewelry:
                return 'Jewelry';
            case Inventory.Furniture:
                return 'Furniture';
            case Inventory.Lighting:
                return 'Lighting';
            case Inventory.Decor:
                return 'Decor';
            case Inventory.Artwork:
            default:
                return 'Artwork';
        }
    },
    options: [
        { value: 0, label: 'Artwork' },
        { value: 5, label: 'Jewelry' },
        { value: 1, label: 'Merchandise' }
    ]
};

const InventoryStatus = [
    { value: 1, label: 'All' },
    { value: 2, label: 'Active' },
    { value: 3, label: 'Inactive' },
    { value: 4, label: 'Available' },
    { value: 5, label: 'Sold' }
];

const InventorySubType = {
    Ring: 0,
    Necklace: 1,
    Bracelet: 2,
    Watch: 3,
    Earrings: 4,
    Cufflinks: 5,
    Brooches: 6,

    Other: 7,

    Chair: 8,
    Sofa: 9,
    Bench: 10,
    Storage: 11,
    Table: 12,

    WallLightAndScone: 13,
    TableLamp: 14,
    FloorLamp: 15,
    Chandelier: 16,

    RugCarpet: 17,
    DecorativeObject: 18,
    Mirror: 19,
    Sculpture: 20,
    Candle: 21,
    Tableware: 22,

    optionsForInventoryType: function (value) {
        switch (value) {
            case Inventory.Jewelry:
                return [
                    { value: 0, label: 'Ring' },
                    { value: 1, label: 'Necklace' },
                    { value: 2, label: 'Bracelet' },
                    { value: 3, label: 'Watch' },
                    { value: 4, label: 'Earrings' },
                    { value: 5, label: 'Cufflinks' },
                    { value: 6, label: 'Brooch' },
                    { value: 7, label: 'Other' }
                ]
            case Inventory.Furniture:
                return [
                    { value: 8, label: 'Chair' },
                    { value: 9, label: 'Sofa' },
                    { value: 10, label: 'Bench' },
                    { value: 11, label: 'Storage' },
                    { value: 12, label: 'Table' },
                    { value: 7, label: 'Other' }
                ]
            case Inventory.Lighting:
                return [
                    { value: 13, label: 'Wall Light and Sconce' },
                    { value: 14, label: 'Table Lamp' },
                    { value: 15, label: 'Floor Lamp' },
                    { value: 16, label: 'Chandelier/Pendant' },
                    { value: 7, label: 'Other' }
                ]
            case Inventory.Decor:
                return [
                    { value: 17, label: 'Rug and Carpet' },
                    { value: 18, label: 'Decorative Object' },
                    { value: 19, label: 'Mirror' },
                    { value: 20, label: 'Sculpture' },
                    { value: 21, label: 'Candle' },
                    { value: 22, label: 'Tableware' },
                    { value: 7, label: 'Other' }
                ]
        }
    }
};

const InvoiceStatus = {
    classNameForValue: function (value) {
        switch (value) {
            case 1:
                return 'tag--open';
            case 2:
                return 'tag--approval';
            case 3:
                return 'tag--closed';
            case 4:
                return 'tag--declined';
        }
    },
    nameForValue: function (value) {
        switch (value) {
            case 1:
                return 'Open';
            case 2:
                return 'On Approval';
            case 3:
                return 'Closed';
            case 4:
                return 'Declined';
        }
    },
    options: [
        { value: 1, label: 'Open' },
        { value: 2, label: 'On Approval' },
        { value: 3, label: 'Closed' },
        { value: 4, label: 'Declined' }
    ]
};

const Invoice = {
    Invoice: 0,
    Offer: 1,
    PurchaseOrder: 2
};

const LeadStatus = [
    { value: 0, label: 'None' },
    { value: 1, label: 'Cold' },
    { value: 2, label: 'Warm' },
    { value: 3, label: 'Hot' }
];

const ListInventory = [
    { label: 'All' },
    { value: 0, label: 'Artwork' },
    { value: 1, label: 'Merchandise' }
];

const MessageLinkType = {
    Marketplace: 'marketplace',
    Website: 'website',
    ArtsyMarketplace: 'artsyMarketplace',
    Custom: 'custom',

    display: (type) => {
        switch (type) {
            case MessageLinkType.Marketplace:
                return 'ArtCloud Marketplace';
            case MessageLinkType.Website:
                return 'Website';
            case MessageLinkType.ArtsyMarketplace:
                return 'Artsy Marketplace';
        }
    },

    options: (isArtsy, labelProp = 'label') => {
        const options = [MessageLinkType.Website, MessageLinkType.Marketplace].map(value => ({ value, [labelProp]: MessageLinkType.display(value) }))
        if (isArtsy) {
            options.push({ value: MessageLinkType.ArtsyMarketplace, [labelProp]: MessageLinkType.display(MessageLinkType.ArtsyMarketplace) });
        }
        return options;
    }
};

const MetricLessFeet = [
    { value: 1, label: 'Centimeters' },
    { value: 0, label: 'Inches' }
];

const Metric = {
    values: [
        ...MetricLessFeet,
        { value: 2, label: 'Feet' }
    ],

    display: (type) => {
        switch (type) {
            case 0:
                return 'Inches';
            case 1:
                return 'Centimeters';
            case 2:
                return 'Feet';
        }
    },

    shortName: (type) => {
        switch (type) {
            case 0:
                return 'in';
            case 1:
                return 'cm';
            case 2:
                return 'ft';
        }
    }
};

const OnboardingIntent = {
    Crm: 8,
    Website: 1,
    Collateral: 4,
    EmailCampaign: 2,
    BusinessOperations: 16,
    Marketplace: 32,

    Action: {
        ContactCreated: 0,
        MessageCreated: 1,
        FollowupCreated: 2,
        InterestCreated: 3,

        InventoryCreated: 4,
        BrandPackageSelected: 5,
        PageEdited: 6,
        ProfileEdited: 7,

        ExportCreated: 8,
        CollateralSent: 9,

        AudienceCreated: 10,
        CampaignCreated: 11,

        InvoiceCreated: 12,
        ReportViewed: 13,

        MarketplaceImageAdded: 14,
        MarketplaceBioAdded: 15,
        MarketplaceOpted: 16
    },

    display: (intent) => {
        switch (intent) {
            case OnboardingIntent.BusinessOperations:
                return "Business Operations";
            case OnboardingIntent.Collateral:
                return "Collateral Builder";
            case OnboardingIntent.Crm:
                return "Sales Tools";
            case OnboardingIntent.EmailCampaign:
                return "Email Campaign";
            case OnboardingIntent.Marketplace:
                return "Marketplace";
            case OnboardingIntent.Website:
                return "Website";
        }
    },
}

const Opt = {
    Resource: {
        Artist: 'artist',
        Exhibition: 'exhibition',
        Inventory: 'inventory',
        List: 'list',
        NewArrival: 'new arrival'
    },
    Url: {
        Marketplace: 'Marketplace',
        Website: 'Website'
    }
}

const Ownership = [
    { value: 1, label: 'Consignment' },
    { value: 2, label: 'Owned' }
];

const PageLayout = [
    { value: 0, label: 'Slideshow' },
    { value: 1, label: 'Grid' },
    { value: 2, label: 'Pinterest' }
];

const PageTypes = {
    Custom: 0,
    Inventory: 1,
    Artists: 2,
    Exhibitions: 3,
    Contact: 5,
    ExternalLink: 6,

    options: () => [
        { value: PageTypes.Custom, label: 'Custom' },
        { value: PageTypes.Inventory, label: 'Inventory' },
        { value: PageTypes.Artists, label: 'Artists' },
        { value: PageTypes.Exhibitions, label: 'Exhibitions' },
        { value: PageTypes.Contact, label: 'Contact' },
        { value: PageTypes.ExternalLink, label: 'External Link' }
    ]
};

const Quicklist = [
    { value: 0, label: 'List' },
    { value: 1, label: 'Exhibition' },
    { value: 3, label: 'Private Exhibition' }
];

const SearchOperators = {
    _Contains: { value: 'ct', label: 'Contains' },
    _EndsWith: { value: 'ew', label: 'Ends With' },
    _StartsWith: { value: 'sw', label: 'Starts With' },

    all: () => [SearchOperators._StartsWith],
    text: () => [
        SearchOperators._Contains,
        SearchOperators._StartsWith
    ]
};

const SocialPlatform = {
    options: [
        { value: 0, label: 'Instagram' },
        { value: 1, label: 'Facebook' },
        { value: 6, label: 'Bluesky' },
        { value: 2, label: 'Twitter/X' },
        { value: 3, label: 'Pinterest' },
        { value: 4, label: 'TikTok' },
        { value: 5, label: 'LinkedIn' },
        { value: 7, label: 'WhatsApp' }
    ],

    prefix: (type) => {
        switch (type) {
            case 0:
                return 'https://www.instagram.com/';
            case 1:
                return 'https://www.facebook.com/@';
            case 2:
                return 'https://twitter.com/@';
            case 3:
                return 'https://www.pinterest.com/';
            case 4:
                return 'https://www.tiktok.com/@';
            case 5:
                return 'https://www.linkedin.com/in/';
            case 6:
                return 'https://bsky.app/profile/';
            case 7:
                return 'https://wa.me/';
        }
    }
};

const SortOrder = [
    { value: 0, label: 'Title' },
    { value: 1, label: 'Artist' },
    { value: 2, label: 'Inventory # (Asc)' },
    { value: 3, label: 'Inventory # (Desc)' },
    { value: 4, label: 'SKU (Asc)' },
    { value: 12, label: 'SKU (Desc)' },
    { value: 5, label: 'Location' },
    { value: 6, label: 'Price (Asc)' },
    { value: 7, label: 'Price (Desc)' },
    { value: 8, label: 'Acquisition Date (Asc)' },
    { value: 9, label: 'Acquisition Date (Desc)' },
    { value: 10, label: 'Year (Asc)' },
    { value: 11, label: 'Year (Desc)' }
];

const Subscription = {
    Campaign: {
        Tier: {
            None: 0,
            TwentyFiveThousand: 1,
            FiftyThousand: 2,
            OneHundredThousand: 3,
            OneHundredAndFiftyThousand: 4,
            TwoHundredThousand: 5,
            ThreeHundredThousand: 6,
            FourHundredThousand: 7,
            FiveHundredThousand: 8
        }
    },

    Product: {
        Manager: 'Manager',
        Marketplace: 'Marketplace',
        Website: 'Website',

        getValue: function (productType) {
            switch (productType) {
                case Subscription.Product.Manager:
                    return 0;
                case Subscription.Product.Website:
                    return 1;
            }
        }
    },

    Tier: {
        Basic: 'Basic',
        Free: 'Free',
        Pro: 'Pro',
        ProPlus: 'ProPlus',

        getDisplay: function (tierType) {
            switch (tierType) {
                case Subscription.Tier.ProPlus:
                    return "Pro Plus";
                default:
                    return tierType;
            }
        },

        getType: function (tierValue) {
            switch (tierValue) {
                case 1:
                    return Subscription.Tier.Basic;
                case 2:
                    return Subscription.Tier.Pro;
                case 3:
                    return Subscription.Tier.ProPlus;
                default:
                    return Subscription.Tier.Free;
            }
        },

        getValue: function (tierType) {
            switch (tierType) {
                case Subscription.Tier.Basic:
                    return 1;
                case Subscription.Tier.Pro:
                    return 2;
                case Subscription.Tier.ProPlus:
                    return 3;
                default:
                    return 0;
            }
        }
    },

    User: {
        Artist: 'Artist',
        Collector: "Collector",
        Gallery: "Gallery",

        getType: function (userValue) {
            switch (userValue) {
                case 2:
                    return Subscription.User.Artist;
                case 1:
                case 3:
                    return Subscription.User.Gallery;
                case 6:
                    return Subscription.User.Collector;
            }
        },

        getValue: function (userType) {
            switch (userType) {
                case Subscription.User.Artist:
                    return 2;
                case Subscription.User.Collector:
                    return 6;
                case Subscription.User.Gallery:
                    return 3;
            }
        }
    }
};
Subscription.Campaign.Tier._price = {
    [Subscription.Campaign.Tier.None]: 0,
    [Subscription.Campaign.Tier.TwentyFiveThousand]: 25,
    [Subscription.Campaign.Tier.FiftyThousand]: 50,
    [Subscription.Campaign.Tier.OneHundredThousand]: 75,
    [Subscription.Campaign.Tier.OneHundredAndFiftyThousand]: 100,
    [Subscription.Campaign.Tier.TwoHundredThousand]: 125,
    [Subscription.Campaign.Tier.ThreeHundredThousand]: 180,
    [Subscription.Campaign.Tier.FourHundredThousand]: 230,
    [Subscription.Campaign.Tier.FiveHundredThousand]: 250,
};
Subscription.Campaign.Tier.getPrice = function (campaignTierType) {
    return Subscription.Campaign.Tier._price[campaignTierType];
};
Subscription.Campaign.Tier.options = [
    { value: Subscription.Campaign.Tier.None, label: '10,000 (Included with Pro Plus)' },
    { value: Subscription.Campaign.Tier.TwentyFiveThousand, label: `25,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.TwentyFiveThousand)} /month)` },
    { value: Subscription.Campaign.Tier.FiftyThousand, label: `50,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FiftyThousand)} /month)` },
    { value: Subscription.Campaign.Tier.OneHundredThousand, label: `100,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.OneHundredThousand)} /month)` },
    { value: Subscription.Campaign.Tier.OneHundredAndFiftyThousand, label: `150,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.OneHundredAndFiftyThousand)} /month)` },
    { value: Subscription.Campaign.Tier.TwoHundredThousand, label: `200,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.TwoHundredThousand)} /month)` },
    { value: Subscription.Campaign.Tier.ThreeHundredThousand, label: `300,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.ThreeHundredThousand)} /month)` },
    { value: Subscription.Campaign.Tier.FourHundredThousand, label: `400,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FourHundredThousand)} /month)` },
    { value: Subscription.Campaign.Tier.FiveHundredThousand, label: `500,000 (+ $${Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FiveHundredThousand)} /month)` }
]

Subscription.UserSubscriptionTier = {
    ArtistManagerBasic: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    ArtistManagerFree: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Free}`,
    ArtistManagerPro: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,
    ArtistManagerProPlus: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.ProPlus}`,
    ArtistWebsiteBasic: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.Basic}`,
    ArtistWebsitePro: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.Pro}`,
    ArtistWebsiteProPlus: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.ProPlus}`,
    CollectorManagerBasic: `${Subscription.User.Collector}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    CollectorManagerPro: `${Subscription.User.Collector}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,
    GalleryManagerBasic: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    GalleryManagerFree: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Free}`,
    GalleryManagerPro: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,
    GalleryManagerProPlus: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.ProPlus}`,
    GalleryWebsiteBasic: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Basic}`,
    GalleryWebsitePro: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Pro}`,
    GalleryWebsiteProPlus: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.ProPlus}`,

    calculateSubtotal: function (userType, managerTier, websiteTier, annual, promotionCode) {
        let userSubscriptionTier = `${userType}${Subscription.Product.Manager}${managerTier}`;
        let _subtotal = Subscription.UserSubscriptionTier.getPrice(userSubscriptionTier, annual) || 0;
        if (websiteTier) {
            userSubscriptionTier = `${userType}${Subscription.Product.Website}${websiteTier}`;
            _subtotal += (Subscription.UserSubscriptionTier.getPrice(userSubscriptionTier, annual) || 0);
        }
        if (promotionCode) {
            if (promotionCode.AmountOff) {
                _subtotal -= (promotionCode.AmountOff / 100.0);
            } else if (promotionCode.PercentOff) {
                _subtotal *= ((100.0 - promotionCode.PercentOff) / 100.0);
            }
        }
        return _subtotal;
    }
};
Subscription.UserSubscriptionTier._price = {
    [Subscription.UserSubscriptionTier.ArtistManagerBasic]: 29,
    [Subscription.UserSubscriptionTier.ArtistManagerFree]: 0,
    [Subscription.UserSubscriptionTier.ArtistManagerPro]: 79,
    [Subscription.UserSubscriptionTier.ArtistManagerProPlus]: 149,
    [Subscription.UserSubscriptionTier.ArtistWebsiteBasic]: 19,
    [Subscription.UserSubscriptionTier.ArtistWebsitePro]: 49,
    [Subscription.UserSubscriptionTier.ArtistWebsiteProPlus]: 99,
    [Subscription.UserSubscriptionTier.CollectorManagerBasic]: 0,
    [Subscription.UserSubscriptionTier.CollectorManagerPro]: 19,
    [Subscription.UserSubscriptionTier.GalleryManagerBasic]: 79,
    [Subscription.UserSubscriptionTier.GalleryManagerFree]: 0,
    [Subscription.UserSubscriptionTier.GalleryManagerPro]: 149,
    [Subscription.UserSubscriptionTier.GalleryManagerProPlus]: 299,
    [Subscription.UserSubscriptionTier.GalleryWebsiteBasic]: 49,
    [Subscription.UserSubscriptionTier.GalleryWebsitePro]: 99,
    [Subscription.UserSubscriptionTier.GalleryWebsiteProPlus]: 149
};
Subscription.UserSubscriptionTier._priceAnnual = {
    [Subscription.UserSubscriptionTier.ArtistManagerBasic]: 313,
    [Subscription.UserSubscriptionTier.ArtistManagerFree]: 0,
    [Subscription.UserSubscriptionTier.ArtistManagerPro]: 853,
    [Subscription.UserSubscriptionTier.ArtistManagerProPlus]: 1609,
    [Subscription.UserSubscriptionTier.ArtistWebsiteBasic]: 205,
    [Subscription.UserSubscriptionTier.ArtistWebsitePro]: 529,
    [Subscription.UserSubscriptionTier.ArtistWebsiteProPlus]: 1069,
    [Subscription.UserSubscriptionTier.CollectorManagerBasic]: 0,
    [Subscription.UserSubscriptionTier.CollectorManagerPro]: 205,
    [Subscription.UserSubscriptionTier.GalleryManagerBasic]: 853,
    [Subscription.UserSubscriptionTier.GalleryManagerFree]: 0,
    [Subscription.UserSubscriptionTier.GalleryManagerPro]: 1609,
    [Subscription.UserSubscriptionTier.GalleryManagerProPlus]: 3229,
    [Subscription.UserSubscriptionTier.GalleryWebsiteBasic]: 529,
    [Subscription.UserSubscriptionTier.GalleryWebsitePro]: 1069,
    [Subscription.UserSubscriptionTier.GalleryWebsiteProPlus]: 1609
};
Subscription.UserSubscriptionTier.getPrice = function (userSubscriptionTierType, annual) {
    if (annual) {
        return Subscription.UserSubscriptionTier._priceAnnual[userSubscriptionTierType];
    }
    return Subscription.UserSubscriptionTier._price[userSubscriptionTierType];
};

const Tag = {
    nameForValue: function (value, multiple) {
        switch (parseInt(value, 10)) {
            case 0:
                return 'Artist Tag' + (multiple == true ? 's' : '');
            case 1:
                return 'Inventory Tag' + (multiple == true ? 's' : '');
            case 2:
                return 'Contact Interest' + (multiple == true ? 's' : '');
            case 3:
                return 'Contact Tag' + (multiple == true ? 's' : '');
            case 4:
                return 'Art Location' + (multiple == true ? 's' : '');
            case 5:
                return 'Artist' + (multiple == true ? 's' : '');
            case 6:
                return 'Art Medium' + (multiple == true ? 's' : '');
            case 7:
                return 'Contact Origin' + (multiple == true ? 's' : '');
            case 8:
                return 'Exhibition Tag' + (multiple == true ? 's' : '');
            case 11:
                return 'Invoice Tag' + (multiple == true ? 's' : '');
            case 12:
                return 'Invoice Origin' + (multiple == true ? 's' : '');
            default:
                return 'Tag' + (multiple == true ? 's' : '');
        }
    }
};

const Tax = [
    { value: 0, label: 'Sales' },
    { value: 1, label: 'GST' },
    { value: 3, label: 'VAT' },
    { value: 2, label: 'None' },

];

const Theme = {
    AccountType: {
        Gallery: 1,
        Artist: 2
    }
}

const TimeZone = [
    { label: '(UTC-12:00) International Date Line West', value: 'Dateline Standard Time' },
    { label: '(UTC-11:00) Coordinated Universal Time-11', value: 'UTC-11' },
    { label: '(UTC-10:00) Aleutian Islands', value: 'Aleutian Standard Time' },
    { label: '(UTC-10:00) Hawaii', value: 'Hawaiian Standard Time' },
    { label: '(UTC-09:30) Marquesas Islands', value: 'Marquesas Standard Time' },
    { label: '(UTC-09:00) Alaska', value: 'Alaskan Standard Time' },
    { label: '(UTC-09:00) Coordinated Universal Time-09', value: 'UTC-09' },
    { label: '(UTC-08:00) Baja California', value: 'Pacific Standard Time (Mexico)' },
    { label: '(UTC-08:00) Coordinated Universal Time-08', value: 'UTC-08' },
    { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'Pacific Standard Time' },
    { label: '(UTC-07:00) Arizona', value: 'US Mountain Standard Time' },
    { label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', value: 'Mountain Standard Time (Mexico)' },
    { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'Mountain Standard Time' },
    { label: '(UTC-06:00) Central America', value: 'Central America Standard Time' },
    { label: '(UTC-06:00) Central Time (US & Canada)', value: 'Central Standard Time' },
    { label: '(UTC-06:00) Easter Island', value: 'Easter Island Standard Time' },
    { label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', value: 'Central Standard Time (Mexico)' },
    { label: '(UTC-06:00) Saskatchewan', value: 'Canada Central Standard Time' },
    { label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', value: 'SA Pacific Standard Time' },
    { label: '(UTC-05:00) Chetumal', value: 'Eastern Standard Time (Mexico)' },
    { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'Eastern Standard Time' },
    { label: '(UTC-05:00) Haiti', value: 'Haiti Standard Time' },
    { label: '(UTC-05:00) Havana', value: 'Cuba Standard Time' },
    { label: '(UTC-05:00) Indiana (East)', value: 'US Eastern Standard Time' },
    { label: '(UTC-05:00) Turks and Caicos', value: 'Turks And Caicos Standard Time' },
    { label: '(UTC-04:00) Asuncion', value: 'Paraguay Standard Time' },
    { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Atlantic Standard Time' },
    { label: '(UTC-04:00) Caracas', value: 'Venezuela Standard Time' },
    { label: '(UTC-04:00) Cuiaba', value: 'Central Brazilian Standard Time' },
    { label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', value: 'SA Western Standard Time' },
    { label: '(UTC-04:00) Santiago', value: 'Pacific SA Standard Time' },
    { label: '(UTC-03:30) Newfoundland', value: 'Newfoundland Standard Time' },
    { label: '(UTC-03:00) Araguaina', value: 'Tocantins Standard Time' },
    { label: '(UTC-03:00) Brasilia', value: 'E. South America Standard Time' },
    { label: '(UTC-03:00) Cayenne, Fortaleza', value: 'SA Eastern Standard Time' },
    { label: '(UTC-03:00) City of Buenos Aires', value: 'Argentina Standard Time' },
    { label: '(UTC-03:00) Greenland', value: 'Greenland Standard Time' },
    { label: '(UTC-03:00) Montevideo', value: 'Montevideo Standard Time' },
    { label: '(UTC-03:00) Punta Arenas', value: 'Magallanes Standard Time' },
    { label: '(UTC-03:00) Saint Pierre and Miquelon', value: 'Saint Pierre Standard Time' },
    { label: '(UTC-03:00) Salvador', value: 'Bahia Standard Time' },
    { label: '(UTC-02:00) Coordinated Universal Time-02', value: 'UTC-02' },
    { label: '(UTC-02:00) Mid-Atlantic - Old', value: 'Mid-Atlantic Standard Time' },
    { label: '(UTC-01:00) Azores', value: 'Azores Standard Time' },
    { label: '(UTC-01:00) Cabo Verde Is.', value: 'Cape Verde Standard Time' },
    { label: '(UTC) Coordinated Universal Time', value: 'UTC' },
    { label: '(UTC+00:00) Casablanca', value: 'Morocco Standard Time' },
    { label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', value: 'GMT Standard Time' },
    { label: '(UTC+00:00) Monrovia, Reykjavik', value: 'Greenwich Standard Time' },
    { label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', value: 'W. Europe Standard Time' },
    { label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', value: 'Central Europe Standard Time' },
    { label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', value: 'Romance Standard Time' },
    { label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 'Central European Standard Time' },
    { label: '(UTC+01:00) West Central Africa', value: 'W. Central Africa Standard Time' },
    { label: '(UTC+02:00) Amman', value: 'Jordan Standard Time' },
    { label: '(UTC+02:00) Athens, Bucharest', value: 'GTB Standard Time' },
    { label: '(UTC+02:00) Beirut', value: 'Middle East Standard Time' },
    { label: '(UTC+02:00) Cairo', value: 'Egypt Standard Time' },
    { label: '(UTC+02:00) Chisinau', value: 'E. Europe Standard Time' },
    { label: '(UTC+02:00) Damascus', value: 'Syria Standard Time' },
    { label: '(UTC+02:00) Gaza, Hebron', value: 'West Bank Standard Time' },
    { label: '(UTC+02:00) Harare, Pretoria', value: 'South Africa Standard Time' },
    { label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', value: 'FLE Standard Time' },
    { label: '(UTC+02:00) Jerusalem', value: 'Israel Standard Time' },
    { label: '(UTC+02:00) Kaliningrad', value: 'Kaliningrad Standard Time' },
    { label: '(UTC+02:00) Khartoum', value: 'Sudan Standard Time' },
    { label: '(UTC+02:00) Tripoli', value: 'Libya Standard Time' },
    { label: '(UTC+02:00) Windhoek', value: 'Namibia Standard Time' },
    { label: '(UTC+03:00) Baghdad', value: 'Arabic Standard Time' },
    { label: '(UTC+03:00) Istanbul', value: 'Turkey Standard Time' },
    { label: '(UTC+03:00) Kuwait, Riyadh', value: 'Arab Standard Time' },
    { label: '(UTC+03:00) Minsk', value: 'Belarus Standard Time' },
    { label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd', value: 'Russian Standard Time' },
    { label: '(UTC+03:00) Nairobi', value: 'E. Africa Standard Time' },
    { label: '(UTC+03:30) Tehran', value: 'Iran Standard Time' },
    { label: '(UTC+04:00) Abu Dhabi, Muscat', value: 'Arabian Standard Time' },
    { label: '(UTC+04:00) Astrakhan, Ulyanovsk', value: 'Astrakhan Standard Time' },
    { label: '(UTC+04:00) Baku', value: 'Azerbaijan Standard Time' },
    { label: '(UTC+04:00) Izhevsk, Samara', value: 'Russia Time Zone 3' },
    { label: '(UTC+04:00) Port Louis', value: 'Mauritius Standard Time' },
    { label: '(UTC+04:00) Saratov', value: 'Saratov Standard Time' },
    { label: '(UTC+04:00) Tbilisi', value: 'Georgian Standard Time' },
    { label: '(UTC+04:00) Yerevan', value: 'Caucasus Standard Time' },
    { label: '(UTC+04:30) Kabul', value: 'Afghanistan Standard Time' },
    { label: '(UTC+05:00) Ashgabat, Tashkent', value: 'West Asia Standard Time' },
    { label: '(UTC+05:00) Ekaterinburg', value: 'Ekaterinburg Standard Time' },
    { label: '(UTC+05:00) Islamabad, Karachi', value: 'Pakistan Standard Time' },
    { label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 'India Standard Time' },
    { label: '(UTC+05:30) Sri Jayawardenepura', value: 'Sri Lanka Standard Time' },
    { label: '(UTC+05:45) Kathmandu', value: 'Nepal Standard Time' },
    { label: '(UTC+06:00) Astana', value: 'Central Asia Standard Time' },
    { label: '(UTC+06:00) Dhaka', value: 'Bangladesh Standard Time' },
    { label: '(UTC+06:00) Omsk', value: 'Omsk Standard Time' },
    { label: '(UTC+06:30) Yangon (Rangoon)', value: 'Myanmar Standard Time' },
    { label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: 'SE Asia Standard Time' },
    { label: '(UTC+07:00) Barnaul, Gorno-Altaysk', value: 'Altai Standard Time' },
    { label: '(UTC+07:00) Hovd', value: 'W. Mongolia Standard Time' },
    { label: '(UTC+07:00) Krasnoyarsk', value: 'North Asia Standard Time' },
    { label: '(UTC+07:00) Novosibirsk', value: 'N. Central Asia Standard Time' },
    { label: '(UTC+07:00) Tomsk', value: 'Tomsk Standard Time' },
    { label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', value: 'China Standard Time' },
    { label: '(UTC+08:00) Irkutsk', value: 'North Asia East Standard Time' },
    { label: '(UTC+08:00) Kuala Lumpur, Singapore', value: 'Singapore Standard Time' },
    { label: '(UTC+08:00) Perth', value: 'W. Australia Standard Time' },
    { label: '(UTC+08:00) Taipei', value: 'Taipei Standard Time' },
    { label: '(UTC+08:00) Ulaanbaatar', value: 'Ulaanbaatar Standard Time' },
    { label: '(UTC+08:30) Pyongyang', value: 'North Korea Standard Time' },
    { label: '(UTC+08:45) Eucla', value: 'Aus Central W. Standard Time' },
    { label: '(UTC+09:00) Chita', value: 'Transbaikal Standard Time' },
    { label: '(UTC+09:00) Osaka, Sapporo, Tokyo', value: 'Tokyo Standard Time' },
    { label: '(UTC+09:00) Seoul', value: 'Korea Standard Time' },
    { label: '(UTC+09:00) Yakutsk', value: 'Yakutsk Standard Time' },
    { label: '(UTC+09:30) Adelaide', value: 'Cen. Australia Standard Time' },
    { label: '(UTC+09:30) Darwin', value: 'AUS Central Standard Time' },
    { label: '(UTC+10:00) Brisbane', value: 'E. Australia Standard Time' },
    { label: '(UTC+10:00) Canberra, Melbourne, Sydney', value: 'AUS Eastern Standard Time' },
    { label: '(UTC+10:00) Guam, Port Moresby', value: 'West Pacific Standard Time' },
    { label: '(UTC+10:00) Hobart', value: 'Tasmania Standard Time' },
    { label: '(UTC+10:00) Vladivostok', value: 'Vladivostok Standard Time' },
    { label: '(UTC+10:30) Lord Howe Island', value: 'Lord Howe Standard Time' },
    { label: '(UTC+11:00) Bougainville Island', value: 'Bougainville Standard Time' },
    { label: '(UTC+11:00) Chokurdakh', value: 'Russia Time Zone 10' },
    { label: '(UTC+11:00) Magadan', value: 'Magadan Standard Time' },
    { label: '(UTC+11:00) Norfolk Island', value: 'Norfolk Standard Time' },
    { label: '(UTC+11:00) Sakhalin', value: 'Sakhalin Standard Time' },
    { label: '(UTC+11:00) Solomon Is., New Caledonia', value: 'Central Pacific Standard Time' },
    { label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', value: 'Russia Time Zone 11' },
    { label: '(UTC+12:00) Auckland, Wellington', value: 'New Zealand Standard Time' },
    { label: '(UTC+12:00) Coordinated Universal Time+12', value: 'UTC+12' },
    { label: '(UTC+12:00) Fiji', value: 'Fiji Standard Time' },
    { label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', value: 'Kamchatka Standard Time' },
    { label: '(UTC+12:45) Chatham Islands', value: 'Chatham Islands Standard Time' },
    { label: '(UTC+13:00) Coordinated Universal Time+13', value: 'UTC+13' },
    { label: '(UTC+13:00) Nuku\'alofa', value: 'Tonga Standard Time' },
    { label: '(UTC+13:00) Samoa', value: 'Samoa Standard Time' },
    { label: '(UTC+14:00) Kiritimati Island', value: 'Line Islands Standard Time' }
];

const Trial = {
    None: 0,
    Trialing: 1,
    Expired: 2,
    Subscribed: 3,
    Delinquent: 4
};

const User = {
    Artist: 2,
    Gallery: 3,
    Collector: 6,

    options: [
        { value: 2, label: 'Artist' },
        { value: 3, label: 'Gallery' },
        { value: 6, label: 'Collector' }
    ]
};

const Walltag = {
    nameForValue: function (value) {
        switch (value) {
            case 15:
                return 'avery5163';
            case 16:
                return 'avery5160';
            case 17:
                return 'avery8871';
            case 18:
                return 'avery22822';
            case 19:
                return 'avery5164';
            case 20:
                return 'avery5164left';
        }
    },

    valueForName: function (name) {
        switch (name) {
            case 'avery5163':
                return 15;
            case 'avery5160':
                return 16;
            case 'avery8871':
                return 17;
            case 'avery22822':
                return 18;
            case 'avery5164':
                return 19;
            case 'avery5164left':
                return 20;
        }
    }
};

const WeightMetric = {
    options: [
        { value: 0, label: 'Pounds' },
        { value: 1, label: 'Kilograms' },
        { value: 2, label: 'Grams' },
    ],

    shortName: (type) => {
        switch (type) {
            case 0:
                return 'lb';
            case 1:
                return 'kg';
            case 2:
                return 'g';
        }
    }
};

const YesNo = [
    { value: 0, label: 'No' },
    { value: 1, label: 'Yes' }
];

module.exports = {
    AcceptedPayment,
    AccountTypes,
    ActiveStatus,
    ActivityType,
    Address,
    AdminUserType,
    AnalyticsDateRangeOptions,
    BillingPermission,
    Composition,
    Consignment,
    ConsignmentCost,
    ConsignmentStatus,
    Currency,
    DateFormats,
    DayOfWeek,
    DetailsDisplay,
    Edition,
    Email,
    Font,
    Gate,
    Genre,
    Inventory,
    InventoryStatus,
    InventorySubType,
    Invoice,
    InvoiceStatus,
    LeadStatus,
    ListInventory,
    MessageLinkType,
    Metric,
    MetricLessFeet,
    OnboardingIntent,
    Opt,
    Ownership,
    PageLayout,
    PageTypes,
    Quicklist,
    SearchOperators,
    SocialPlatform,
    SortOrder,
    Subscription,
    Tag,
    Tax,
    Theme,
    TimeZone,
    Trial,
    User,
    Walltag,
    WeightMetric,
    YesNo
}
